// extracted by mini-css-extract-plugin
module.exports = {"boximage":"styles_boximage__2IZN9"};